<template>
    <div>
        <AppHeader @navBarToggle="navBarToggle"></AppHeader>
        <router-view :scrollPos="scrollPos" ></router-view>
        <AppFooter></AppFooter>
        <v-dialog @before-open="beforeOpenModal"/>
    </div>
</template>

<script>
import AppHeader from './components/AppHeader';
import AppFooter from './components/AppFooter';

export default {
    name: 'App',
    components: {
        AppHeader,
        AppFooter
    },
    data() {
        return {
            scrollPos: 0
        }
    },
    methods: {
        navBarToggle() {
            const navBarToggle = document.querySelector('#navBarToggle');
            const navBar = document.querySelector('#navBar');
            //const navBarWidth = navBar.offsetWidth;
            //window.console.log('navBarWidth', navBarWidth);
            //window.console.log('left: '+getComputedStyle(navBar).left);
            if (getComputedStyle(navBar).left == '0px') {
                //navBarToggle.style.left = '0px';
                //navBar.style.left = (navBarWidth*-1).toString() + 'px';
                navBarToggle.classList = '';
                navBar.className = 'slideOut';
            }
            else {
                //navBarToggle.style.left = navBarWidth.toString() + 'px';
                //navBar.style.left = '0px';
                navBarToggle.classList = 'close';
                navBar.className = 'slideIn';
                
            }
        },
        beforeOpenModal(e) {
            window.console.log(e.params);
        }
    },
    ready: function(){
        this.$scrollSet();
    },
    
}
</script>

<style lang="less">
#forte {
    background: url(../public/images/forte.png) no-repeat left top;
    display: block;
    height: 240px;
    overflow: hidden;
    margin: 1em auto;
    text-indent: -99999px;
    width: 78px;
}
#navBarToggle {
    box-shadow: 5px 0px 10px rgba(0,0,0,0.2);

    //background: #ee2e24 url(../public/images/forte3.png) no-repeat center center;
    background: @red;
    cursor: pointer;
    display: block;
    left: 120px;
    height: 65px;
    outline: 0;
    position: absolute;
    top: 50px;
    width: 40px;
    z-index: 1035;

    &:before {
        border-top: 2px solid #fff;
        border-bottom: 2px solid #fff;
        //outline: 1px solid #fff;
        //outline-bottom: 1px solid #fff;
        content: '';
        height: 3px;
        position: absolute;
        margin-top: -7px;
        top: 50%;
        left: 25%;
        width: 50%;
    }
    &:after {
        border-bottom: 2px solid #fff;
        content: '';
        height: 3px;
        position: absolute;
        top: 50%;
        left: 25%;
        width: 50%;
    }

    &.close:before {
        border-top: none;
        margin-top: -2px;
        margin-left: -1px;
        transform: rotate(-45deg);
    }
    &.close:after {
        margin-top: -2px;
        margin-left: 1px;
        transform: rotate(45deg);
    }
}

#navBar {
    box-shadow: 5px 0px 10px rgba(0,0,0,0.2);

    background: url(../public/images/nav-bg.gif) repeat left top;
    left: -120px;
    height: 100%;
    position: fixed;
    padding: 10px 0 0;
    right: auto;
    width: 120px;
    z-index: 10;
}
nav ul {
    margin: 0;
    padding: 0;

    li {
        margin: 0;
        padding: 0;
        position: relative;
        
        &.active:before {
            border-left: 5px solid #fefefe;
            border-bottom: 5px solid transparent;
            border-top: 5px solid transparent;
            
            content: "";
            height: 0px;
            margin: -6px 0 0;
            position: absolute;
            right: 5px;
            top: 50%;
            width: 0px;
            z-index: 1;
        }
        
        a {
            color: @txtColor;
            cursor: pointer;
            display: block;
            font-size: 0.786em;
            font-weight: 700;
            padding: 20px 0 20px;
            
            text-transform: uppercase;
            text-align: center;

            &:hover {
                background: @red2;
                color: @lightColor;
                text-decoration: none;
            }
            

            
        }
        &.active a {
            background: @red2;
            color: @lightColor;
            
        }
    }
    #logo.active:before {
        border: none;
    }
}

#page_Home {
    overflow: hidden;
}

div.page {
    //min-height: 600px;

    header {
        .boxPadding;
        .hgroup;
        padding-top: 10%;
        padding-bottom: 10%;
        background: @red;
        color: @lightColor;
        margin: 0 0;
        
        p {
            margin: 0;
        }
        figure img {
            margin: 0;
        }
    }
    .content-container {
        .boxPadding;
    }

    
}

@media only screen and (min-width : 768px) {
    body {
        padding-left: 120px;
    }
    #navBarToggle {
        display: none;
    }
    #navBar {
        left: 0;

        #navOurForte a {
            background: url(../public/images/nav-our-forte.png) no-repeat center 10px;
        }
        #navOurForte a:hover,
        #navOurForte.active a	{
            background: @red2 url(../public/images/nav-our-forte.png) no-repeat center -90px;
        }
        #navExperience a {
            background: url(../public/images/nav-experience.png) no-repeat center 10px;
        }
        #navExperience a:hover,
        #navExperience.active a	{
            background: @red2 url(../public/images/nav-experience.png) no-repeat center -90px;
        }
        #navAchievements a {
            background: url(../public/images/nav-achievements.png) no-repeat center 10px;
        }
        #navAchievements a:hover,
        #navAchievements.active a	{
            background: @red2 url(../public/images/nav-achievements.png) no-repeat center -90px;
        }
        #navGlory a {
            background: url(../public/images/nav-glory.png) no-repeat center 10px;
        }
        #navGlory a:hover,
        #navGlory.active a {
            background: @red2 url(../public/images/nav-glory.png) no-repeat center -90px;
        }
        #navGallery a {
            background: url(../public/images/nav-gallery.png) no-repeat center 10px;
        }
        #navGallery a:hover,
        #navGallery.active a {
            background: @red2 url(../public/images/nav-gallery.png) no-repeat center -90px;
        }
        #navContact a {
            background: url(../public/images/nav-contact.png) no-repeat center 10px;
        }
        #navContact a:hover,
        #navContact.active a{
            background: @red2 url(../public/images/nav-contact.png) no-repeat center -90px;
        }

        li {
            a {
                padding: 47px 0 8px;
            }

        }
    }

    div.page {
        header {
            padding-top: 30px;
            padding-bottom: 30px;
        }
    }
}
</style>